<template>
  <div class="dlg">
    <header class="dlg__head">
      <div class="dlg__eyebrow">
        <span class="dlg__dot"></span>
        WAIZMANNVERGLEICH / ANNAHMECHECK · KRITERIEN
      </div>
      <h2 class="dlg__title">
        Anonymer Antrag-Annahmecheck: berücksichtigte Kriterien
      </h2>
      <p class="dlg__sub">
        Wir prüfen bereits <strong>vor der Antragstellung</strong>, ob Ihr
        Antrag angenommen würde – so vermeiden Sie unnötige Ablehnungen.
      </p>
    </header>

    <div class="dlg__table-wrap">
      <table class="dlg__table">
        <thead>
          <tr>
            <th>Antragsfrage</th>
            <th>Ihre Angabe</th>
            <th>Annahme</th>
            <th>Antragsablehnung möglich, weil…</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rows" :key="row.label">
            <td><strong>{{ row.label }}</strong></td>
            <td>
              <span class="ak-answer">{{ row.value }}</span>
            </td>
            <td>
              <span class="dlg__pill dlg__pill--ok">Antrag möglich</span>
            </td>
            <td>{{ row.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
  import { computed, defineProps } from "vue";

  const props = defineProps({
    berechnung: {
      type: Object,
      default: () => ({}),
    },
  });

  const b = computed(() => props.berechnung || {});

  const rows = computed(() => {
    const r = [];
    r.push({
      label: "Alter",
      value: `${b.value.ber_tag}.${b.value.ber_monat}.${b.value.ber_jahr}`,
      note:
        "Einige Versicherungen haben ein Mindest- oder Maximal-Eintrittsalter.",
    });

    if (b.value.ber_segment == 2 || b.value.ber_segment == 3) {
      r.push({
        label: "Sehhilfen vorhanden",
        value: b.value.ber_brille_ja == 1 ? "Ja" : "Nein",
        note:
          "Einige Versicherungen lehnen einen Antrag bei vorhandenen Sehhilfen ab.",
      });
    }
    if (b.value.ber_segment == 2) {
      r.push({
        label: "Augenkrankheiten",
        value: b.value.ber_brille_krankheit == 1 ? "Ja" : "Nein",
        note: "Bestehende Augenkrankheiten können zu Antragsablehnungen führen.",
      });
    }
    if (b.value.ber_segment == 3 || b.value.ber_segment == 4) {
      r.push({
        label: "Vorerkrankungen",
        value:
          b.value.ber_top_gesund == 1
            ? "keine schwereren Vorerkrankungen"
            : "Ja, Vorerkrankungen vorhanden",
        note:
          "Einige Versicherungen lehnen einen Antrag bei Vorerkrankungen ab.",
      });
    }

    if (b.value.ber_segment <= 1) {
      r.push({
        label: "Aufbiss-Schiene",
        value: b.value.ber_aufbiss == 1 ? "Ja, vorhanden" : "Nein",
        note:
          "Einige Versicherungen lehnen einen Antrag bei vorhandener Aufbiss-Schiene ab.",
      });
      r.push({
        label: "Laufende Behandlung",
        value:
          b.value.ber_zahnmass == 1
            ? "Ja, laufende oder angeratene Behandlung"
            : "Nein",
        note:
          "Bei laufenden oder angeratenen Behandlungen lehnen manche Versicherungen den Antrag ab.",
      });
      r.push({
        label: "Parodontosebehandlung",
        value:
          b.value.ber_zb_3 == 1
            ? "Ja, laufende Parodontosebehandlung"
            : "Nein",
        note:
          "Bei vorhandener Parodontosebehandlung lehnen viele Gesellschaften einen Antrag ab.",
      });
      r.push({
        label: "Zahnfehlstellung",
        value:
          b.value.ber_zahnfehl == 1 ? "Ja, Fehlstellung vorhanden" : "Nein",
        note:
          "Bei einer vorhandenen Zahnfehlstellung ist eine Versicherung bei einigen Gesellschaften nicht möglich.",
      });
      r.push({
        label: "Fehlende Zähne",
        value: b.value.ber_ze_ja == 1 ? "Ja, fehlende Zähne" : "Nein",
        note:
          "Bei vorhandenen Lücken ist eine Ablehnung des Antrags bei einigen Versicherungen möglich.",
      });
      r.push({
        label: "Anzahl Lücken",
        value: String(b.value.ber_luecke ?? 0),
        note:
          "Einige Versicherungen lehnen einen Antrag bei zu vielen Lücken ab.",
      });
      r.push({
        label: "Mitversicherung fehlender Zähne",
        value:
          b.value.ber_luecke_vers == 1
            ? "Ja, fehlende Zähne sollen mitversichert werden"
            : "Nein",
        note:
          "Bei den meisten Versicherungen ist eine Versicherung von fehlenden Zähnen nicht möglich.",
      });
      r.push({
        label: "Anzahl Prothesen",
        value: String(b.value.ber_zahnersetzt ?? 0),
        note:
          "Einige Versicherungen lehnen einen Antrag bei zu vielen Prothesen ab.",
      });
      r.push({
        label: "Anzahl Kronen",
        value: String(b.value.ber_kronen ?? 0),
        note:
          "Einige Versicherungen lehnen einen Antrag bei zu vielen Kronen ab.",
      });
      r.push({
        label: "Anzahl Brücken",
        value: String(b.value.ber_bruecke ?? 0),
        note:
          "Einige Versicherungen lehnen einen Antrag bei Brücken ab.",
      });
    }

    return r;
  });
</script>

<style scoped>
  .ak-answer {
    font-weight: 700;
    color: #0f4c81;
  }
</style>
